import { useCommonSlideshow } from './slideshow.hooks';
import { ActivityBuilderPrintSlideshowImage } from 'approot/activity-builder/print/activity-builder-print-image.style';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ViewProps } from './slideshow.constants';
import { getPrintImage } from '../shared/logic/get-print-image';
import { ImageViewFill } from '../image/image-print';
import * as Styled from './slideshow-view.style';
import { SlideshowPrintContainer } from './slideshow-print.style';

const SlideshowPrint = ({ slideshowImages, properties }: ViewProps) => {
  const { slides, imageDimensions, setContainerElement } = useCommonSlideshow({
    slideshowImages,
    selectedIndex: 0,
    captureKeypress: false,
  });

  const slide = slides?.[0];

  return (
    <ComponentAspectRatio dimensions={properties.dimensionData}>
      <ComponentAbsoluteWrapper $centred={false}>
        <SlideshowPrintContainer ref={setContainerElement}>
          <Styled.SlideshowWrapper>
            <Styled.SlideshowPages $isLoading={false}>
              {slide && (
                <ActivityBuilderPrintSlideshowImage>
                  {!slide.properties.cropData ? (
                    <img
                      src={getPrintImage(slide.properties.imageUrls)}
                      alt={slide.properties.altText || ''}
                      style={{ ...imageDimensions }}
                    />
                  ) : (
                    <ImageViewFill
                      imageUrl={getPrintImage(slide.properties.imageUrls)}
                      altText={slide.properties.altText}
                    />
                  )}
                </ActivityBuilderPrintSlideshowImage>
              )}
            </Styled.SlideshowPages>
          </Styled.SlideshowWrapper>
          <Styled.SlideshowPageControls>
            <span>{`Page 1 of ${slides.length}`}</span>
          </Styled.SlideshowPageControls>
        </SlideshowPrintContainer>
      </ComponentAbsoluteWrapper>
    </ComponentAspectRatio>
  );
};

export default SlideshowPrint;
